import { Component, Input } from '@angular/core';

@Component({
  selector: 'mfp-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent {
  @Input() alert: 'info' | 'warning' | 'success' | 'danger' = 'info';

  constructor() {}
}
